<script lang="ts">
  export let name: string = '';
</script>

<div class="store-name-container">
  {#if name}
    <h1 
      class="store-name">
      {name}
    </h1>
  {/if}
</div>

<style lang="scss">
  .store-name-container {
    width: 100%;
  }

  .store-name {
    font-size: inherit;
    font-family: inherit;
    color: inherit;
    font-weight: inherit;
  }
</style>
